// extracted by mini-css-extract-plugin
export default {"Credits":"Credits_Credits__iSAYw","CreditsText":"Credits_CreditsText__emooD","href":"Credits_href__Picrc","short":"Credits_short__QKb+y","margin":"Credits_margin__tFzI1"};